import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {FileAttachment, FileAttachmentsV1Service} from "../../../apis/backend";
import {NgbPopover} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'file-attachment-display',
    templateUrl: 'file-attachment-display.component.html'
})
export class FileAttachmentDisplayComponent {
    
    @Input('FileAttachment')
    public FileAttachment: FileAttachment;
    
    @Input('EditMode')
    public EditMode: boolean;
    
    @Output('Delete')
    public DeleteEvent = new EventEmitter<FileAttachment>(true);
    
    @ViewChild('DisplayNameInput')
    private _displayNameInput: ElementRef<HTMLInputElement>;

    @ViewChild('ConfirmDelete')
    private _confirmDelete: NgbPopover;
    
    constructor(private _fileAttachmentService: FileAttachmentsV1Service) {}

    public DownloadFile() {
        // TODO: Intercept the url from this and feed it to window.open()
        this._fileAttachmentService.getFileAttachment(
            this.FileAttachment.FileAttachmentID,
            true,
            'response')
            .subscribe(file => {
                let filename = file.headers.get('Content-Disposition')
                    .split(';')
                    .map(d => d.trim())
                    .find(d => d.startsWith('filename='))
                    .substring('filename='.length);

                let url = URL.createObjectURL(file.body);
                let downloadLink = document.createElement('a');
                //downloadLink.download = filename;
                downloadLink.href = url;
                downloadLink.target = '_blank';
                downloadLink.click();
            });
    }

    public RenameClick() {
        if (this._displayNameInput.nativeElement.disabled) {
            this._displayNameInput.nativeElement.disabled = false;
            return;
        }
        this.RenameFile();
    }

    public RenameFile() {
        let filename = this._displayNameInput.nativeElement.value.trim();
        if (!filename) {
            return;
        }
        this._fileAttachmentService.renameFileAttachment(this.FileAttachment.FileAttachmentID, filename)
            .subscribe(() => {
                this.FileAttachment.DisplayName = filename;
                this._displayNameInput.nativeElement.disabled = true;
            });
    }
    
    public DeleteFile() {
        this.DeleteEvent.emit(this.FileAttachment);
        this._confirmDelete.close();
    }

    public CloseConfirmDelete() {
        this._confirmDelete.close();
    }
}